/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Faq_TitleInputs */

const en_dr_faq_title = /** @type {(inputs: Dr_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you open a room`)
};

const id_dr_faq_title = /** @type {(inputs: Dr_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelum membuka ruang`)
};

/**
* | output |
* | --- |
* | "Before you open a room" |
*
* @param {Dr_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_faq_title = /** @type {((inputs?: Dr_Faq_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Faq_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_faq_title(inputs)
	return en_dr_faq_title(inputs)
});